import React, { useEffect, useState } from 'react'
import Field from 'components/controls/field'
import Button from 'components/controls/button'
import history from 'routes/history'
import { localizedTranslate } from 'assets/localization'
import { connect } from 'react-redux'
import { validatePasswordWithError, validate } from 'shared/helpers/validate'
import { validateEmailWithError } from 'shared/helpers/validate'
import { loginRequest, updatePasswordRequest, closeResetPasswordModal, toggleI2andQsToolUserModal, sendResetPasswordEmailRequest } from 'store/login/loginActions'
import Modal from 'components/modal'
import ChangePasswordModal from 'components/change-password-modal'
import auth from "utils/auth"
import I2andQsToolUserModal from 'components/i2-qsTool-user-modal'


import 'less/login.less'

function mapStateToProps(state) {
  return {
    t: localizedTranslate('en', state.translations.en_us),
    showLoginFailed: state.login.showLoginFailed,
    loginSuccessed: state.login.loginSuccessed,
    longToken: state.login.longToken,
    loading: state.login.loading,
    loginRoles: state.login.roles,
    terms: state.login.terms,
    isOpen: state.login.isOpen,
    isLoading:state.login.loading,
    showAcceptTermsMessage: state.login.showAcceptTermsMessage,
    showErrorMessage: state.login.showErrorMessage,
    status: state.login.status,
    isI2andQsToolUserModalOpen: state.login.isI2andQsToolUserModalOpen,
    isSubmitting: state.login.isSubmitting,
    emailSent:state.login.emailSent,
    user: state.user
  }
}

const Login = (props) => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [emailErrorMessage, setEmailErrorMessage] = useState("")
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("")
  const [emailValid, setEmailValid] = useState(true)
  const [passwordValid, setPasswordValid] = useState(true)
  const [loginClicked, setLoginClicked] = useState(false)
  const [showTermsMsg, setShowTermsMsg] = useState(false)
  const [showTermsModal, setShowTermsModal] = useState(false)
  const [showTermsAcceptedModal, setShowTermsAcceptedModal] = useState(false)
  const [resetPasswordEmail, setResetPasswordEmail] = useState("")
  const [resetPasswordEmailValid, setResetPasswordEmailValid ] = useState(true)
  const [resetPasswordClicked, setResetPasswordClicked ] = useState(false)
  const [resetPasswordErrorMessage, setResetPasswordEmailErrorMessage] = useState("")
  const [rememberMe, setRememberMe] = useState(false)
  const [emailSent,setEmailSent] = useState(props.emailSent)
  const isForgetPassword = window.location.href.indexOf("forgotPassword") > -1

  const handleValidation = () => {
    if (email.length > 0) {
      setEmailValid(validate(validateEmailWithError, email))
      setEmailErrorMessage(props.t("email.error.message"))
    } else {
      setEmailErrorMessage(props.t("required.field"))
    }
    if (password.length > 0) {
      setPasswordValid(validate(validatePasswordWithError, password))
      setPasswordErrorMessage(props.t("password.error.message"))
    } else {
      setPasswordErrorMessage(props.t("required.field"))
    }
    setLoginClicked(true)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      isForgetPassword ? handleResetPasswordValidation() :  handleValidation()
    }
  }

  const handleResetPasswordValidation = () => { 
    if (resetPasswordEmail.length > 0) {
      setResetPasswordEmailValid(validate(validateEmailWithError, resetPasswordEmail))
      setResetPasswordEmailErrorMessage(props.t("email.error.message"))
    } else {
      setResetPasswordEmailErrorMessage(props.t("required.field"))
    }
    setResetPasswordClicked(true)
  }

  useEffect(() => {
    if (props.loginSuccessed || auth.isAuth()) {
      console.log("props in login ", props)
      let isProjectManager = props.loginRoles.includes('QUAL_SCHEDULER_MANAGER')
      let isAdmin = props.loginRoles.includes('QUAL_SCHEDULER_ADMIN')
      const hasProjectManager = props.user.userRole === 2
      const hasAdmin = props.user.userRole === 3
      if (isProjectManager || hasProjectManager || isAdmin || hasAdmin) {
        history.push("/projects")
      }
      else {
        history.push("/interviews")
      }
    }
  }, [props.loginSuccessed])

  useEffect(() => {
    if (props.terms !== '') {
      setShowTermsMsg(true)
    }
  }, [props.terms])

  useEffect(() => {
    if (emailValid.isValid === true && passwordValid.isValid === true && password.length >0 && email.length >0 ) {
      props.loginRequest({ email, password })
    }
  }, [emailValid, passwordValid])

  // QUAL-2135: this used to ask the API whether the address belonged to a real user, and
  // whether that user also used InCrowd Interview, then branched three ways on the answer.
  // Asking was the vulnerability: the reply confirmed account existence to anyone who typed
  // an address, so a script could turn a list of harvested addresses into a confirmed
  // customer list. The screen now takes the same path for every address - show the InCrowd
  // warning, then send the reset mail - so it reveals nothing about who has an account.
  useEffect(() => {
    // Guarded because this is now synchronous: opening used to wait on the API round trip,
    // so a second submit while the modal was open would have toggled it shut.
    if (resetPasswordEmailValid.isValid === true && resetPasswordEmail.length >0 && !props.isI2andQsToolUserModalOpen) {
      props.toggleI2andQsToolUserModal()
    }
  }, [resetPasswordEmailValid])

  useEffect(() => {
    setEmailSent(props.emailSent)
  }, [props.emailSent])

  useEffect(() => {
    setEmailSent(false)
  }, [resetPasswordEmail])



  // QUAL-2135: the 'unknown.user.message' branch ("We can't find a user with that email
  // address") is gone. It was the same disclosure as the API's, rendered on screen: anyone
  // could type an address and be told whether it belonged to an account. Every address now
  // gets the same confirmation, which is why its wording is conditional ("If an account
  // exists...") rather than promising mail that may never be sent.
  const handleSetheaderMessage = () => {
    if (isForgetPassword && emailSent && resetPasswordEmail.length > 0) {
      return props.t('reset.password.email')
    } else if (!isForgetPassword && props.showLoginFailed && email.length > 0) {
      return props.t("invalid_login")
    } else {
      return props.t("please.login")
    }
  }

  return (
    <div>
      <div className="separator"></div>
      <div className='main-apollo-logo' />
      <div className="main-login">
        <div className="main-login-right">
          <div className="main-login-right-container">
            <div className="login-text">
              {!showTermsMsg ? <span> {handleSetheaderMessage()} </span>
                : <div className="terms-and-conditions-msg"> {`${props.t('user.error.no_accept_terms')} `} <a className="terms-link" onClick={() => setShowTermsModal(true)}>{props.t('here')}</a></div>
              }
            </div>
            <div className="email" >
              {isForgetPassword ?
                <div>
                  <div className="forgot-password-text">
                    <p>
                      <div> Email </div>
                      <i className='help-link' dangerouslySetInnerHTML={{
                        __html: props.t('forgot.passwor.note', {
                          markup: { tagStart: `<a href='mailto:interviews@opinionsiteanswers.com' />` }
                        })
                      }} />
                    </p>
                  </div>
                  <Field
                    type="basic"
                    name="open-ended"
                    onChange={(e) => setResetPasswordEmail(e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e)}
                    value={resetPasswordEmail}
                  />
                </div>
                :
                <Field
                  type="basic"
                  name="open-ended"
                  label="Email"
                  onChange={(ee) => setEmail(ee.target.value)}
                  onKeyDown={(ee) => handleKeyDown(ee)}
                  value={email}
                />}
            </div>
            {!isForgetPassword && ((email.length === 0 && loginClicked) || (email.length > 0 && emailValid.isValid === false)) &&
              <div className="form-field-row">
                <span> {emailErrorMessage} </span>
              </div>}
            {isForgetPassword && ((resetPasswordEmail.length === 0 && resetPasswordClicked) || (resetPasswordErrorMessage.length > 0 && resetPasswordEmailValid.isValid === false)) &&
              <div className="form-field-row">
                <span> {resetPasswordErrorMessage} </span>
              </div>}  
            {!isForgetPassword && <div className="password">
              <Field
                type="password"
                name="open-ended"
                label="Password"
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => handleKeyDown(e)}
              />
            </div>}
            {!isForgetPassword && ((password.length === 0 && loginClicked) || (password.length > 0 && passwordValid.isValid === false)) &&
              <div className="form-field-row">
                <span> {passwordErrorMessage} </span>
              </div>}
            {/* <Field
                type="checkbox"
                label={props.t("remember.me")}
                onClick= {(e )=> setRememberMe(e.target.checked)}
              /> */}
            {isForgetPassword ?
              <a className="forgot-password" href="/login"> {" ← I remembered my password"} </a>
              :
              <a className="forgot-password" href="/forgotPassword"> {props.t("forgot.password.message")} </a>}
            <div className={`${isForgetPassword ? 'forgot-password-button' : 'login-button'}${props.loading ? '-loading' : ''}`}>
              <Button
                className={isForgetPassword ? "forgot-password" : "login"}
                onClick={isForgetPassword ? handleResetPasswordValidation : handleValidation}
                isLoading={props.loading}
              > {isForgetPassword ? props.t("reset.password") :  props.t("login")}
                <i className="spin-me im-arrow-right2" />
              </Button>
            </div>
            <div className="required-fields" >
              <span>{props.t("required.fields")}</span>
            </div>
          </div>
        </div>
        <div className="main-login-left">
          <div className="login-logo-container" >
            <div className="i-wrap">
              <i className="im-lock2"></i>
            </div>
            <span>{ isForgetPassword ? props.t("reset.password") :props.t("login")}</span>
          </div>
        </div>
      </div>
      <div className="footer" >
        <div className="footer-info"></div>
        <div className="footer-line"></div>
        {/* <div className='footer-nav'>
        <a className='about-us' href='https://www.incrowdnow.com/what-we-do/'>About</a>
        <a className='contact' href='https://www.incrowdnow.com/contact-us/'>Contact</a>
        <a className='privacy' href='https://www.incrowdnow.com/privacy'>Privacy</a>
        <a className='terms' href='https://www.incrowdnow.com/terms'>Terms</a>
      </div> */}
        <span >{props.t("appolo.rights")}</span>
      </div>
      {showTermsModal && <Modal
        isOpen={showTermsModal}
        className="terms-modal"
        title={"Terms and Conditions"}
        cancelable={false}
        submitBtnText={"Proceed to Login"}
        onSubmit={() => {
          setShowTermsModal(false);
          setShowTermsAcceptedModal(true)
        }}
      >
        <div className={`sample-size-container`} dangerouslySetInnerHTML={{ __html: props.terms }}>
        </div>
      </Modal>}

      {showTermsAcceptedModal && <Modal
        isOpen={showTermsAcceptedModal}
        className="terms-accepted-modal"
        title={"Terms and Conditions"}
        cancelable={false}
        submitBtnText={"Proceed to Dashboard"}
        onSubmit={() => {
          props.loginRequest({ email, password, termsAccepted: true });
          setShowTermsAcceptedModal(false)
        }}
      >
        <div className={`terms-accepted-text`}>
          {props.t('user.success.accepted_terms')}
        </div>
      </Modal>}
      <ChangePasswordModal
        isOpen={props.isOpen}
        t={props.t}
        updatePasswordRequest={props.updatePasswordRequest}
        isLoading={props.isLoading}
        showAcceptTermsMessage={props.showAcceptTermsMessage}
        closeResetPasswordModal={props.closeResetPasswordModal}
        showErrorMessage={props.showErrorMessage}
        status={props.status}
        {...props}
      ></ChangePasswordModal>

      <I2andQsToolUserModal
        isOpen={props.isI2andQsToolUserModalOpen}
        t={props.t}
        onSubmit={props.sendResetPasswordEmailRequest}
        onCancel={props.toggleI2andQsToolUserModal}
        resetPasswordEmail={resetPasswordEmail}
        isSubmitting={props.isSubmitting}
      ></I2andQsToolUserModal>
    </div>
  )
}

const mapDispatch = {
  loginRequest,
  updatePasswordRequest,
  closeResetPasswordModal,
  toggleI2andQsToolUserModal,
  sendResetPasswordEmailRequest
}

export default connect(mapStateToProps, mapDispatch)(Login)
